export enum PortalSessionStatusEnum {
  CREATED = 'CREATED',
  LOGGED_IN = 'LOGGED_IN',
  LOGGED_OUT = 'LOGGED_OUT',
  NOT_YET_ACTIVATED = 'NOT_YET_ACTIVATED',
  ACTIVATED = 'ACTIVATED',
  _UNKNOWN = '_UNKNOWN',
}
